import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  resolveFormSource,
  resolveFormSourceBackLabel,
  resolveFormSourceReturnRoute,
} from './utils/form-source.util';

/**
 * Resolves which module (Feeds or Re-Entry Planning) opened a Forms sub-page from the
 * `?source=` query param, so back / save / cancel return there after refresh or a direct link.
 * @returns {{ source: string, returnRoute: string, backLabel: string }}
 */
export const useFormSourceHook = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const source = resolveFormSource(search);
    return {
      source,
      returnRoute: resolveFormSourceReturnRoute(source),
      backLabel: resolveFormSourceBackLabel(source),
    };
  }, [search]);
};
